module.exports = __webpack_public_path__ + "img/chain_industry-solution3.917106d7.png";